<template>

    <div>

        <div class="custom-form-section mb-0">

            <div class="row">

                <div class="col-md-24">

                    <input-check-radio
                        type="checkbox"
                        name="booking_is_active"
                        v-model="booking_is_active"
                        :options="[
                            {value: true, label: 'Aktivera bokning på denna arbetsplatsen'},
                        ]"
                        formGroupClass="mb-8"
                    />

                </div>

            </div>

            <div class="row" v-if="booking_is_active">
                <div class="col-md-12">

                    <input-text-area
                        name="booking_description"
                        label="Kort beskrivning, max 2-3 meningar"
                        v-model="booking_description"
                        height="80px"
                    />

                    <input-text
                        name="booking_url"
                        label="Länk till Boka direkt"
                        custom-error-message="En länk krävs för att kunna spara."
                        v-model="booking_url"
                    />

                    <input-text
                        name="timezynk_id"
                        label="TimeZynk-ID"
                        custom-error-message="Ett TimeZynk-ID krävs för att kunna spara."
                        v-model="timezynk_id"
                    />

                </div>

                <div class="col-md-12">

                    <input-text
                        name="clinic_name_person"
                        label="Massörens namn (valfritt)"
                        v-model="clinic_name_person"
                    />

                    <input-text-area
                        name="clinic_description"
                        label="Kort text om massören (valfritt)"
                        v-model="clinic_description"
                        height="160px"
                    />

                    <div class="row">

                        <div class="col-6">
                            <div class="position-relative w-100 bg-primary" style="padding-top:100%;">
                                <div class="position-absolute w-100 h-100" style="z-index:1; top:0; left:0; border-radius: 50%; overflow: hidden; background-color: #efefef;">
                                   <img :src="'/storage/workplace-clinic-images/'+clinic_image" class="w-100 h-100" v-if="clinic_image">
                                </div>
                            </div>
                            <div class="w-100 mt-2 d-flex justify-content-center" v-if="clinic_image">
                                <button class="btn btn-sm btn-danger" @click="clinic_image = null" v-if="clinic_image">
                                    Ta bort bild
                                </button>
                            </div>
                        </div>

                        <div class="col-18 pt-2">

                            <div class="custom-form-group">
                              <label for="booking-clinic-title" class="form-label">Bild på massören (valfritt)</label>
                              <input class="form-control" type="file" id="booking-clinic-title" @change="upload">
                              <div class="custom-info">Rekommenderad storlek: 400 x 400 pixlar.</div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="w-100 d-flex justify-content-end pt-4">
            <button class="btn btn-primary" @click="patcherPatch()" :disabled="patcher.submitted">
                Spara
            </button>
        </div>

    </div>

</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import axios from 'axios'

export default {
    mixins: [
        patcher
    ],

    props: {
        workplace: {
            required: true
        }
    },

    data () {
        return {
            booking_is_active: this.workplace.booking_is_active,
            booking_description: this.workplace.booking_description,
            booking_url: this.workplace.booking_url,
            clinic_name_person: this.workplace.clinic_name_person,
            clinic_image: this.workplace.clinic_image,
            clinic_description: this.workplace.clinic_description,
            timezynk_id: this.workplace.timezynk_id
        }
    },

    computed: {
        patcherUrl () {
            return '/workplaces/' + this.workplace.id
        },

        patcherData () {
            return {
                booking_is_active: this.booking_is_active,
                booking_description: this.booking_description,
                booking_url: this.booking_url,
                clinic_name_person: this.clinic_name_person,
                clinic_image: this.clinic_image,
                clinic_description: this.clinic_description,
                timezynk_id: this.timezynk_id
            }
        }
    },

    methods: {
        upload (event) {
            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)

            axios.post(
                '/workplaces/' + this.workplace.id + '/uploadClinicImage',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.clinic_image = response.data.clinic_image
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
        },

        patcherSuccess () {
            this.$emit('refresh')
            bus.$emit(
                'notify',
                'Ändringarna har sparats.'
            )
        }
    }
}
</script>
